import { render, staticRenderFns } from "./echarts.vue?vue&type=template&id=1a64ec82&scoped=true"
import script from "./echarts.vue?vue&type=script&lang=js"
export * from "./echarts.vue?vue&type=script&lang=js"
import style0 from "./echarts.vue?vue&type=style&index=0&id=1a64ec82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a64ec82",
  null
  
)

export default component.exports